module.exports = __webpack_public_path__ + "static/tat-44-cfc4ffbf01a2022e05a9cebfce24fad4.jpg";